// Polyfill lockdown. This file must be the very first import from
// src/index.tsx so its side effects run before React, Thirdweb,
// Civic, or any other Web3 / UMD code evaluates. Anything that
// expects a Node-style `global`, `Buffer`, or `process` on the
// window finds it here.

import { Buffer } from 'buffer';
import process from 'process';

type WindowWithPolyfills = Window &
  typeof globalThis & {
    Buffer:  typeof Buffer;
    process: typeof process;
    global:  Window & typeof globalThis;
  };

const w = window as unknown as WindowWithPolyfills;

w.Buffer  = Buffer;
w.process = process;
// Civic's ethereum-gateway UMD (and several Thirdweb deps) expect
// `global` to exist. Without this, they throw `Q is not a function`
// under MetaMask's SES lockdown the moment they evaluate.
w.global  = w;

export {};
